<template>
    <form-group :validator="v.code" :label="label" :label-for="id" :description="tip">
        <template slot-scope="{ attrs, listeners }">
          <v-select :id="id"  
                :inputId="id"
                :options="options"
                :getOptionLabel="option => option.description"
                :value="value"
                aria-label="Search for school name"   
                screenreader="Search for school name" 
                @input="onSelected"
                :data-test="slug"
                v-bind="attrs"
                :state="v.$dirty ? !v.$error : null"
                v-on="listeners">
            <template slot="no-options">
                Type to search school names.
            </template>
            <template #search="{attributes, events}">
                    <input
                    class="vs__search"
                    :required="!value"
                    v-bind="attributes"
                    v-on="events"
                    />
            </template>
        </v-select>

        </template>
      </form-group>
</template>

<script>
import _ from "lodash"
import axios from "axios"

export default {
    props: {
        value: [Object],
        label: [String],
        tip: [String],
        v: [Object],
        slug: [String]
    },

    data() {
        return {
            defaultSelection: {
                code: '',
                description: ''
            },
            options: [
                { code: "UNIV-00001",  description: "Aesthetiq Institute , Oakdale , 55128"  },
{ code: "UNIV-00002",  description: "American Institute of Nondestructive Testing , Baxter , 56425"  },
{ code: "UNIV-00004",  description: "Arch Language Network , Little Canda , 55117"  },
{ code: "UNIV-00005",  description: "Ashtangasana Yoga Studio Training , Elk River , 55330"  },
{ code: "UNIV-00006",  description: "Atelier Academy of Beauty , Hopkins , 55343"  },
{ code: "UNIV-00007",  description: "Avivo Institute of Career and Technical Education , Minneapolis , 55406"  },
{ code: "UNIV-00008",  description: "Awaken Pilates , Minneapolis , 55408"  },
{ code: "UNIV-00009",  description: "Black Swan Solutions , Lakeville , 55044"  },
{ code: "UNIV-00010",  description: "Brainco , Minneapolis , 55408"  },
{ code: "UNIV-00011",  description: "Bravura Training , St. Louis Park , 55416"  },
{ code: "UNIV-00012",  description: "Builders Institute , Brooklyn Park , 55443"  },
{ code: "UNIV-00013",  description: "CompTIA Tech Career Academy , Edina , 55439"  },
{ code: "UNIV-00014",  description: "CorePower Yoga , Minneapolis , 55415"  },
{ code: "UNIV-00015",  description: "Devanadi Yoga , Minneapolis , 55410"  },
{ code: "UNIV-00016",  description: "Diverse Media Institute , St. Paul , 55104"  },
{ code: "UNIV-00017",  description: "Energy Healing International , Eden Prairie , 55344"  },
{ code: "UNIV-00018",  description: "Faces ETC Makeup Artist School of Minnesota , Minneapolis , 55419"  },
{ code: "UNIV-00019",  description: "Good Vibrations Yoga , Hopkins , 55343"  },
{ code: "UNIV-00020",  description: "Goodwill Industries Inc/Easter Seals Minnesota , St. Paul , 55104"  },
{ code: "UNIV-00021",  description: "Green Lotus Yoga and Healing Center , Mendota Heights , 55118"  },
{ code: "UNIV-00022",  description: "Health Partners IME , Minneapolis , 55425"  },
{ code: "UNIV-00023",  description: "HeartWork Studio , Northfield , 55057"  },
{ code: "UNIV-00024",  description: "Hennepin Healthcare School of Laboratory Science , Minneapolis , 55415"  },
{ code: "UNIV-00025",  description: "Intertech , Eagan , 55122"  },
{ code: "UNIV-00026",  description: "Kaplan Real Estate Education , St. Paul , 55108"  },
{ code: "UNIV-00027",  description: "LA Beauty School , Richfield , 55423"  },
{ code: "UNIV-00028",  description: "Language Access Consulting &amp; Training , St. Paul , 55113"  },
{ code: "UNIV-00029",  description: "Learning Journeys International Center of Coaching , Woodbury , 55125"  },
{ code: "UNIV-00030",  description: "Life Time Academy , Minneapolis , 55403"  },
{ code: "UNIV-00031",  description: "LifePower , Eden Prairie , 55346"  },
{ code: "UNIV-00032",  description: "Lonna Mosow's Center for Mind Body Fitness , Eden Prairie , 55344"  },
{ code: "UNIV-00033",  description: "Manufacturers Alliance , Golden Valley , 55426"  },
{ code: "UNIV-00034",  description: "Massage School, The , St. Paul , 55103"  },
{ code: "UNIV-00035",  description: "MidWest School of Diving , White Bear Lake , 55110"  },
{ code: "UNIV-00036",  description: "Minneapolis Yoga Training &amp; Wellness, LLC dba The Yoga Center Retreat , St Louis Park , 55416"  },
{ code: "UNIV-00037",  description: "Minnesota Brows Microblading &amp; Lash Academy, LLC , Edina , 55436"  },
{ code: "UNIV-00038",  description: "Minnesota Commercial Diving Training Center , Brainerd , 56401"  },
{ code: "UNIV-00039",  description: "Minnesota Institute of Ayurveda , Minneapolis , 55406"  },
{ code: "UNIV-00040",  description: "Minnesota School of Piano Technology , White Bear Lake , 55110"  },
{ code: "UNIV-00041",  description: "Muddy Waters Yoga School , Winona , 55987"  },
{ code: "UNIV-00042",  description: "National Able Network, Inc. , Golden Valley , 55422"  },
{ code: "UNIV-00043",  description: "New Horizons Computer Learning Centers , Eagan , 55121"  },
{ code: "UNIV-00044",  description: "North American Medical Academy , Minneapolis , 55430"  },
{ code: "UNIV-00045",  description: "Northtown Brow Academy , Blaine , 55434"  },
{ code: "UNIV-00046",  description: "Northwestern Academy of Homeopathy , St. Louis Park , 55426"  },
{ code: "UNIV-00047",  description: "Online Trading Academy , Bloomington , 55425"  },
{ code: "UNIV-00048",  description: "Paragon Pilates &amp; Physical Therapy , Edina , 55436"  },
{ code: "UNIV-00049",  description: "Pilates MN , Wayzata , 55391"  },
{ code: "UNIV-00050",  description: "Prime Digital Academy , Minneapolis , 55415"  },
{ code: "UNIV-00051",  description: "Rasmussen College (Moorhead) , Moorhead , 56560"  },
{ code: "UNIV-00052",  description: "Red Lake Nation College , Red Lake , 56671"  },
{ code: "UNIV-00053",  description: "Replenish Yoga and Wellness , International Falls , 56649"  },
{ code: "UNIV-00054",  description: "Rio Grooming School &amp; Salon, LLC , Hastings , 55033"  },
{ code: "UNIV-00055",  description: "Rock Gate Capitol, LLC d/b/a 160 Driving Academy , Inver Grove Heights , 55077"  },
{ code: "UNIV-00056",  description: "Saint Mary's University of Minnesota Minneapolis Center , Minneapolis , 55404"  },
{ code: "UNIV-00057",  description: "Six Degrees Studio , Minneapolis , 55410"  },
{ code: "UNIV-00058",  description: "Software Guild , Minneapolis , 55402"  },
{ code: "UNIV-00059",  description: "Spirit of the Lake Yoga &amp; Wellness , Excelsior , 55331"  },
{ code: "UNIV-00060",  description: "Sweatshop , St. Paul , 55104"  },
{ code: "UNIV-00061",  description: "The Professional Massage Academy , Waite Park , 56387"  },
{ code: "UNIV-00062",  description: "The Salon Professional Academy - Maplewood , Maplewood , 55109"  },
{ code: "UNIV-00063",  description: "Townsend Barber Institute , Roseville , 55113"  },
{ code: "UNIV-00064",  description: "TSC Connect , St. Paul , 55130"  },
{ code: "UNIV-00065",  description: "Upward Facing Dawn , Coon Rapids , 55433"  },
{ code: "UNIV-00066",  description: "Washington Online Learning Institute , Minnetonka , 55305"  },
{ code: "UNIV-00067",  description: "Watermark Learning , Minneapolis , 55437"  },
{ code: "UNIV-00068",  description: "Yoga North , Duluth , 55804"  },
{ code: "UNIV-00069",  description: "Zandu Health Initiative , Bloomington , 55420"  },
{ code: "UNIV-00070",  description: "Luxury Laser Education, dba/MedSpa Institute of America , Edina , 55435"  },
{ code: "UNIV-00071",  description: "Minnesota Computers for Schools , Minneapolis , 55414"  },
{ code: "UNIV-00072",  description: "ONX (Sparrow Studios) , Eagan , 55122"  },
{ code: "UNIV-00073",  description: "Pressed School of Yoga , Blaine , 55434"  },
{ code: "UNIV-00074",  description: "Radiant Life Yoga, LLC , Minneapolis , 55408"  },
{ code: "UNIV-00075",  description: "Regions Hospital "  },
{ code: "UNIV-00076",  description: "St. John's University , Collegeville , 56321"  },
{ code: "UNIV-00077",  description: "Symmetry Solutions "  },
{ code: "UNIV-00078",  description: "White Earth Tribal and Community College , Mahnomen , 56557"  },
{ code: "UNIV-00079",  description: "Walden University , Minneapolis , 55401"  },
{ code: "UNIV-00081",  description: "Academy College , Bloomington , 55431"  },
{ code: "UNIV-00082",  description: "Riverland Community College-Albert Lea , Albert Lea , 56007"  },
{ code: "UNIV-00083",  description: "Alexandria Technical &amp; Community College , Alexandria , 56308"  },
{ code: "UNIV-00084",  description: "Takoda Institute of Higher Education , Minneapolis , 55404"  },
{ code: "UNIV-00085",  description: "Anoka Technical College , Anoka , 55303"  },
{ code: "UNIV-00086",  description: "Anoka-Ramsey Community College-Coon Rapids , Coon Rapids , 55433"  },
{ code: "UNIV-00087",  description: "Riverland Community College-Austin , Austin , 55912"  },
{ code: "UNIV-00088",  description: "Riverland Community College-Owatonna , Owatonna , 55060"  },
{ code: "UNIV-00089",  description: "Northwest Technical College , Bemidji , 56601"  },
{ code: "UNIV-00080",  description: "Bemidji State University , Bemidji , 56601"  },
{ code: "UNIV-00090",  description: "Bethany Lutheran College , Mankato , 56001"  },
{ code: "UNIV-00091",  description: "Bethel University , St. Paul , 55112"  },
{ code: "UNIV-00092",  description: "Central Lakes College-Brainerd , Brainerd , 56401"  },
{ code: "UNIV-00093",  description: "Minnesota West Community &amp; Technical College-Canby , Canby , 56220"  },
{ code: "UNIV-00094",  description: "Carleton College , Northfield , 55057"  },
{ code: "UNIV-00095",  description: "Concordia College, Moorhead, Moorhead , 56562"  },
{ code: "UNIV-00096",  description: "Concordia University-St. Paul , St. Paul , 55104"  },
{ code: "UNIV-00097",  description: "Nova Academy of Cosmetology (Mankato) , Mankato , 56001"  },
{ code: "UNIV-00098",  description: "Dakota County Technical College , Rosemount , 55068"  },
{ code: "UNIV-00099",  description: "Minnesota State Community and Technical College-Detroit Lakes , Detroit Lakes , 56501"  },
{ code: "UNIV-00100",  description: "Martin Luther College , New Ulm , 56073"  },
{ code: "UNIV-00101",  description: "Lake Superior College , Duluth , 55811"  },
{ code: "UNIV-00102",  description: "Northland Community &amp; Technical College-East Grand Forks , East Grand Forks , 56721"  },
{ code: "UNIV-00103",  description: "South Central College-Faribault , Faribault , 55021"  },
{ code: "UNIV-00104",  description: "Minnesota State Community and Technical College-Fergus Falls , Fergus Falls , 56537"  },
{ code: "UNIV-00105",  description: "Minnesota West Community &amp; Technical College-Granite Falls , Granite Falls , 56241"  },
{ code: "UNIV-00106",  description: "Gustavus Adolphus College , St. Peter , 56082"  },
{ code: "UNIV-00107",  description: "Hamline University , St. Paul , 55104"  },
{ code: "UNIV-00108",  description: "Hazelden Betty Ford Graduate School of Addiction Studies , Center City , 55012"  },
{ code: "UNIV-00109",  description: "Hennepin Technical College-Brooklyn Park , Brooklyn Park , 55445"  },
{ code: "UNIV-00110",  description: "Hennepin Technical College-Eden Prairie , Eden Prairie , 55347"  },
{ code: "UNIV-00111",  description: "Hibbing Community College , Hibbing , 55746"  },
{ code: "UNIV-00112",  description: "Aveda Arts and Sciences Institute Minneapolis , Minneapolis , 55414"  },
{ code: "UNIV-00113",  description: "Ridgewater College-Hutchinson , Hutchinson , 55350"  },
{ code: "UNIV-00114",  description: "Inver Hills Community College , Inver Grove Heights , 55076"  },
{ code: "UNIV-00115",  description: "Itasca Community College , Grand Rapids , 55744"  },
{ code: "UNIV-00116",  description: "Minnesota West Community &amp; Technical College-Jackson , Jackson , 56143"  },
{ code: "UNIV-00117",  description: "Macalester College , St. Paul , 55105"  },
{ code: "UNIV-00118",  description: "South Central College-Mankato , North Mankato , 56003"  },
{ code: "UNIV-00119",  description: "Minnesota State University-Mankato , Mankato , 56001"  },
{ code: "UNIV-00120",  description: "Mayo Clinic College of Medicine and Science , Rochester , 55905"  },
{ code: "UNIV-00121",  description: "Mesabi Range College-Eveleth , Eveleth , 55734"  },
{ code: "UNIV-00122",  description: "Mesabi Range College-Virginia , Virginia , 55792"  },
{ code: "UNIV-00123",  description: "Metropolitan State University , St. Paul , 55106"  },
{ code: "UNIV-00124",  description: "University of Minnesota Twin Cities , Minneapolis , 55455"  },
{ code: "UNIV-00125",  description: "University of Minnesota Crookston , Crookston , 56716"  },
{ code: "UNIV-00126",  description: "Minneapolis College of Art and Design , Minneapolis , 55404"  },
{ code: "UNIV-00127",  description: "Minneapolis Community &amp; Technical College , Minneapolis , 55403"  },
{ code: "UNIV-00128",  description: "Minneapolis School of Anesthesia , St. Louis Park , 55426"  },
{ code: "UNIV-00129",  description: "Minnesota School of Cosmetology (Woodbury) , Woodbury , 55125"  },
{ code: "UNIV-00130",  description: "University of Minnesota Duluth , Duluth , 55812"  },
{ code: "UNIV-00131",  description: "University of Minnesota Morris , Morris , 56267"  },
{ code: "UNIV-00132",  description: "Minnesota MultiHousing Association , Bloomington , 55431"  },
{ code: "UNIV-00133",  description: "Minnesota School of Horseshoeing , Ramsey , 55303"  },
{ code: "UNIV-00134",  description: "Model College of Hair Design , St. Cloud , 56301"  },
{ code: "UNIV-00135",  description: "Minnesota State Community and Technical College-Moorhead , Moorhead , 56560"  },
{ code: "UNIV-00136",  description: "Minnesota State University Moorhead , Moorhead , 56563"  },
{ code: "UNIV-00137",  description: "North Hennepin Community College , Brooklyn Park , 55445"  },
{ code: "UNIV-00138",  description: "Normandale Community College , Bloomington , 55431"  },
{ code: "UNIV-00139",  description: "North Central University , Minneapolis , 55404"  },
{ code: "UNIV-00140",  description: "Rasmussen College (Bloomington) , Bloomington , 55435"  },
{ code: "UNIV-00141",  description: "Northland Community &amp; Technical College-Thief River Falls , Thief River Falls , 56701"  },
{ code: "UNIV-00142",  description: "University of Northwestern - St. Paul , Roseville , 55113-1598"  },
{ code: "UNIV-00143",  description: "Northwestern Health Sciences University , Bloomington , 55431-1599"  },
{ code: "UNIV-00144",  description: "Oak Hills Christian College , Bemidji , 56601"  },
{ code: "UNIV-00145",  description: "Pine Technical &amp; Community College , Pine City , 55063"  },
{ code: "UNIV-00146",  description: "Minnesota West Community &amp; Technical College-Pipestone , Pipestone , 56164"  },
{ code: "UNIV-00147",  description: "Rainy River Community College , International Falls , 56649"  },
{ code: "UNIV-00148",  description: "Rasmussen College (Eagan) , Eagan , 55122-1346"  },
{ code: "UNIV-00149",  description: "Rasmussen College (Mankato) , Mankato , 56001"  },
{ code: "UNIV-00150",  description: "Minnesota State College Southeast-Red Wing , Red Wing , 55066"  },
{ code: "UNIV-00151",  description: "Rochester Community and Technical College , Rochester , 55904"  },
{ code: "UNIV-00152",  description: "College of Saint Benedict , St. Joseph , 56374-2099"  },
{ code: "UNIV-00153",  description: "St. Cloud Technical &amp; Community College , St. Cloud , 56303"  },
{ code: "UNIV-00154",  description: "St. Cloud State University , St. Cloud , 56301"  },
{ code: "UNIV-00155",  description: "Saint Mary&apos;s University of Minnesota , Winona , 55987"  },
{ code: "UNIV-00156",  description: "St. Olaf College , Northfield , 55057-1098"  },
{ code: "UNIV-00157",  description: "Crown College , St. Bonifacius , 55375-9001"  },
{ code: "UNIV-00158",  description: "College of St. Scholastica, The , Duluth , 55811"  },
{ code: "UNIV-00159",  description: "University of St. Thomas , St. Paul , 55105-1096"  },
{ code: "UNIV-00160",  description: "Empire Beauty School (Bloomington) , Bloomington , 55420"  },
{ code: "UNIV-00161",  description: "St. Catherine University , St. Paul , 55105"  },
{ code: "UNIV-00162",  description: "Rasmussen College (St. Cloud) , St. Cloud , 56301"  },
{ code: "UNIV-00163",  description: "Saint Paul College , St. Paul , 55102"  },
{ code: "UNIV-00164",  description: "Central Lakes College-Staples , Staples , 56479"  },
{ code: "UNIV-00165",  description: "Southwest Minnesota State University , Marshall , 56258"  },
{ code: "UNIV-00166",  description: "The Travel Academy , Eagan , 55121"  },
{ code: "UNIV-00167",  description: "Summit Academy Opportunities Industrialization Center , Minneapolis , 55405"  },
{ code: "UNIV-00168",  description: "Vermilion Community College , Ely , 55731"  },
{ code: "UNIV-00169",  description: "Minnesota State Community and Technical College-Wadena , Wadena , 56482"  },
{ code: "UNIV-00170",  description: "Dunwoody College of Technology , Minneapolis , 55403"  },
{ code: "UNIV-00171",  description: "Ridgewater College-Willmar , Willmar , 56201"  },
{ code: "UNIV-00172",  description: "Minnesota State College Southeast-Winona , Winona , 55987"  },
{ code: "UNIV-00173",  description: "Winona State University , Winona , 55987"  },
{ code: "UNIV-00174",  description: "Mitchell Hamline School of Law , St. Paul , 55105"  },
{ code: "UNIV-00175",  description: "Minnesota West Community &amp; Technical College-Worthington , Worthington , 56187"  },
{ code: "UNIV-00176",  description: "Century College , White Bear Lake , 55110"  },
{ code: "UNIV-00177",  description: "Minnesota School of Barbering , Minneapolis , 55406"  },
{ code: "UNIV-00178",  description: "Adler Graduate School , Minnetonka , 55343"  },
{ code: "UNIV-00179",  description: "Fond du Lac Tribal &amp; Community College , Cloquet , 55720"  },
{ code: "UNIV-00180",  description: "Anoka-Ramsey Community College-Cambridge , Cambridge , 55008"  },
{ code: "UNIV-00181",  description: "Minnesota School of Bartending , St. Paul , 55114"  },
{ code: "UNIV-00182",  description: "Institute of Floristry , Minneapolis , 55413"  },
{ code: "UNIV-00183",  description: "Capella University , Minneapolis , 55402"  },
{ code: "UNIV-00184",  description: "Montessori Training Center of Minnesota , St. Paul , 55106"  },
{ code: "UNIV-00185",  description: "Leech Lake Tribal College , Cass Lake , 56633"  },
{ code: "UNIV-00186",  description: "Hastings Beauty School Inc. , Hastings , 55033"  },
{ code: "UNIV-00187",  description: "Rasmussen College (Brooklyn Park) , Brooklyn Park , 55445"  },
{ code: "UNIV-00188",  description: "Rasmussen College (Lake Elmo) , Lake Elmo , 55042"  },
{ code: "UNIV-00189",  description: "Institute of Production and Recording, The , Minneapolis , 55401"  },
{ code: "UNIV-00190",  description: "Empire Beauty School (Spring Lake Park) , Spring Lake Park , 55432"  },
{ code: "UNIV-00191",  description: "University of Minnesota Rochester , Rochester , 55904"  },
{ code: "UNIV-00192",  description: "CenterPoint Massage &amp; Shiatsu Therapy School &amp; Clinic , St Louis Park , 55416"  },
{ code: "UNIV-00193",  description: "Avalon School of Cosmetology , Worthington , 56187"  },
{ code: "UNIV-00194",  description: "Nova Academy of Cosmetology (Rochester) , Rochester , 55901"  },
{ code: "UNIV-00195",  description: "Minnesota School of Cosmetology (Plymouth) , Plymouth , 55447"  },
{ code: "UNIV-00196",  description: "Bethlehem College and Seminary , Minneapolis , 55415"  },
{ code: "UNIV-00197",  description: "Rasmussen College (Blaine) , Blaine , 55449"  },
{ code: "OTHER",  description: "OTHER" }






            ]

        } 
    },
    
    computed: {
        id() {
            return _.uniqueId('schoolSelector')
        }
    },

    methods: {
        onSelected(item) {
            this.$emit('input', item)
        },
  }
}
</script>

<style>
.vs__dropdown-menu {
    max-height:200px;
}
</style>